

export const application = {
    action: "mdi-robot-mower-outline",
    title: "ApplicationFielForm",
    permission: "application",
    items: [

        {
            prefix: "O",
            title: "Applications",
            link: "/applications",
            permission: "application-index",
        },
        {
            prefix: "O",
            title: "NewApplication",
            link: "/applications/create",
            permission: "application-create",
        },
        {
            prefix: "O",
            title: "RiskLevels",
            link: "/risk_levels",
            permission: "application-risk-level-index",
        },
    ],
}

